import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage = ({ onLogin }) => {
  const [isRegistering, setIsRegistering] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const navigate = useNavigate();

  const secretKeys = [
    "uZRM7TMwcKQTEbcP",
    "nJLSjJ6GsDjASaPt",
    "pwmbE4gPA6F6AeqK",
    "fkKD4zM3cgx4HPNx",
    "9UUZParC4k5wUX68"
  ];

  const getRandomSecretKey = () =>
    secretKeys[Math.floor(Math.random() * secretKeys.length)];

  const storeTokenWithExpiry = (token) => {
    const expiresAt = new Date().getTime() + 8 * 60 * 60 * 1000; // 8 hours
    const data = { token, expiresAt };
    sessionStorage.setItem('userTokenData', JSON.stringify(data));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const secretKey = getRandomSecretKey();

    if (isRegistering) {
      try {
        const res = await fetch('https://app.smartcompliance.ai/api/UserActions/SignUp', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            UserName: email,
            UserRole: 'Consumer',
            UserPassword: password,
            FirstName: firstName,
            LastName: lastName,
            UserEmail: email,
            SecretKey: secretKey
          })
        });

        const signUpData = await res.json();

        if (signUpData?.loginMessage?.toUpperCase() === 'SUCCESS' && signUpData?.userToken) {
          const token = signUpData.userToken;
          storeTokenWithExpiry(token);

          const userRes = await fetch('https://app.smartcompliance.ai/api/UserActions/GetUser', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ UserToken: token, SecretKey: secretKey })
          });

          const userData = await userRes.json();
          sessionStorage.setItem('userData', JSON.stringify(userData));
          onLogin(userData);
          navigate('/dashboard');
        } else {
          alert('Sign up failed. Please try again.');
        }
      } catch (error) {
        console.error('SignUp error:', error);
        alert('Error during sign up.');
      }
    } else {
      try {
        const res = await fetch('https://app.smartcompliance.ai/api/UserActions/SignIn', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            UserName: email,
            UserPassword: password,
            SecretKey: secretKey
          })
        });

        const signInData = await res.json();

        if (signInData?.loginMessage?.toUpperCase() === 'SUCCESS' && signInData?.userToken) {
          const token = signInData.userToken;
          storeTokenWithExpiry(token);

          const userRes = await fetch('https://app.smartcompliance.ai/api/UserActions/GetUser', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ UserToken: token, SecretKey: secretKey })
          });

          const userData = await userRes.json();
          sessionStorage.setItem('userData', JSON.stringify(userData));
          onLogin(userData);
          navigate('/dashboard');
        } else {
          alert('Invalid login. Please check credentials.');
        }
      } catch (error) {
        console.error('Login error:', error);
        alert('Error during login.');
      }
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}>
      <h2>{isRegistering ? 'Create Account' : 'Login'}</h2>
      <form onSubmit={handleSubmit}>
        {isRegistering && (
          <>
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              style={inputStyle}
            />
            <input
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              style={inputStyle}
            />
            <input
              type="tel"
              placeholder="Phone Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              style={inputStyle}
            />
          </>
        )}
        <input
          type="email"
          placeholder="Email (username)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={inputStyle}
        />
        <button type="submit" style={submitStyle}>
          {isRegistering ? 'Register' : 'Login'}
        </button>
      </form>
      <p style={{ marginTop: '10px', textAlign: 'center' }}>
        {isRegistering ? 'Already have an account?' : "Don't have an account?"}
        <button
          onClick={() => setIsRegistering(!isRegistering)}
          style={{ marginLeft: '5px', background: 'none', border: 'none', color: '#4CAF50', cursor: 'pointer' }}
        >
          {isRegistering ? 'Login' : 'Register'}
        </button>
      </p>
    </div>
  );
};

// Basic inline styling
const inputStyle = {
  width: '100%',
  padding: '10px',
  marginBottom: '10px'
};

const submitStyle = {
  width: '100%',
  padding: '10px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none'
};

export default LoginPage;